import {styled} from '@linaria/react';
import React from 'react';
import {COLORS} from '../../../constants/colors';
import {Icon, IconSize} from '../../atoms/Icon/Icon';
import {IconName} from '../../atoms/Icon/IconName';
import {RichText} from '../../atoms/Text/RichText';

type StatusInfoText = string | {text: string};

interface StatusInfoBoxProps {
  className?: string;
  style?: React.CSSProperties;
  icon: IconName;
  iconSize?: keyof typeof IconSize;
  text: StatusInfoText;
  color: keyof typeof COLORS;
}

export const StatusInfoBox: React.FC<StatusInfoBoxProps> = ({
  icon,
  iconSize = 'XS',
  text,
  color,
  ...rest
}) => {
  const content = typeof text === 'string' ? text : text.text;

  return (
    <Wrapper {...rest} $color={color}>
      <Icon size={iconSize} asset={icon} fill={COLORS[color]} />
      <RichText size="px10" color={color}>
        {content}
      </RichText>
    </Wrapper>
  );
};

const Wrapper = styled.div<{$color: StatusInfoBoxProps['color']}>`
  display: flex;
  align-items: center;
  width: fit-content;
  gap: 4px;
  padding: 2px 8px 2px 4px;
  border: ${props => `1px solid ${COLORS[props.$color]}`};
  border-radius: 30px;
`;
